exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.SearchBar{display:inline-flex;align-items:baseline;vertical-align:baseline;justify-content:flex-end\n}\n.SearchBar.-expanded{width:100%\n}\n.SearchBar .search-bar-input,.SearchBar .search-button{height:29px\n}\n.SearchBar .search-bar-input{flex:1 0 auto\n}\n.SearchBar .cancel-search{height:50px\n}\n.SearchBar .cancel-icon{color:#b9b9ba;color:var(--btnTopBarText, #b9b9ba)\n}", ""]);

// exports
